import { render } from "./ServicosHome.vue?vue&type=template&id=94de35d4&scoped=true"
import script from "./ServicosHome.vue?vue&type=script&lang=js"
export * from "./ServicosHome.vue?vue&type=script&lang=js"

import "./ServicosHome.vue?vue&type=style&index=0&id=94de35d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94de35d4"]])

export default __exports__